import { useState } from 'react';

import { useParams } from 'react-router-dom';

import { useMobileStore } from 'store/mobile.store';
import { useVersionStore } from 'store/version.store';

import { useQueryGetCard } from 'api/queries/getMainCard.query';

import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { reportingConfig } from 'components/Dashboards/Reporting/reportingConfig';

export const useMainCardProvider = () => {
    const [showModal, setShowModal] = useState(true);
    const isMobile = useMobileStore((state) => state.isMobile);

    const { cardId } = useParams<{ cardId: string }>();
    const currentVersion = useVersionStore((state) => state.version);

    const versionId =
        window.location.href.indexOf(executionConfig.pinboards.link) === -1 &&
        window.location.href.indexOf(reportingConfig.reporting.link) === -1
            ? currentVersion?.id
            : undefined;

    const getCard = useQueryGetCard({
        id: cardId,
        isVirtual: false,
        versionId,
    });

    return {
        showModal,
        setShowModal,
        isMobile,
        api: {
            getCard,
        },
    };
};
